import React from "react";

class CustomIconButton extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { disabled, onClick, icon = null, title, className = "" } = this.props;

    return (
      <>
        <div
          className={"swift-button-icon " + (disabled ? "disabled" : "") + className}
          onClick={!disabled ? onClick : () => { }}
        >
          <p>{title}</p>
          <div className="button-icon">{icon}</div>
        </div>
      </>
    );
  }
}

export default CustomIconButton;
